<div class="" fxLayout="column" fxLayoutAlign="start center">
  <h1 mat-dialog-title>{{'SHEDULE2_0.CARDS.PASO5.TITULO' | translate}}</h1>
  <div class="dialogContent" mat-dialog-content>
  <table mat-table [dataSource]="tablaDatos" class="mat-elevation-z8">

    <!-- SECCION -->
    <ng-container matColumnDef="section">
      <th mat-header-cell *matHeaderCellDef> {{'SHEDULE2_0.CARDS.PASO5.TABLE.SECTION' | translate}} </th>
      <td mat-cell *matCellDef="let element"> {{element.name_section}} </td>
    </ng-container>

    <!-- VALOR -->
    <ng-container matColumnDef="value">
      <th mat-header-cell *matHeaderCellDef> {{'SHEDULE2_0.CARDS.PASO5.TABLE.VALUE' | translate}} </th>
      <td mat-cell *matCellDef="let element">
        <span *ngIf="element.name_section=='status:' && element.value=='0'">
          {{'SHEDULE2_0.CARDS.PASO5.TABLE.INACTIVE' | translate}}
        </span>
        <span *ngIf="element.name_section=='status:' && element.value=='1'">
          {{'SHEDULE2_0.CARDS.PASO5.TABLE.ACTIVE' | translate}}
        </span>
        <span *ngIf="element.name_section=='status:' && element.value=='2'">
          {{'SHEDULE2_0.CARDS.PASO5.TABLE.CLOSE' | translate}}
        </span>
        <span *ngIf="element.name_section!='status:'">
          {{element.value}}
        </span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  </div>

<div mat-dialog-actions>
<button mat-raised-button color="accent" class="mt-20" (click)="salir()">
  {{'SHEDULE2_0.CERRAR' | translate}}
  <mat-icon class="ml-20">clear</mat-icon>
</button>
</div>
</div>
